import { useIntercom as _useIntercom } from "react-use-intercom";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { formatDate } from "@shared/utils/date";
import { useLocation } from "react-router-dom";
import moment from "moment";
import useMedia from "utils/hooks/useMedia";
import { HIDE_INTERCOM_LAUNCHER_BREAKPOINT } from "common/constants";
import { useIsOnboarding } from "utils/hooks/misc";
import { getAppcuesAndIntercomUserProperties } from "@shared/analytics/utils";
import { useSharedIntercom } from "@shared/utils/hooks/misc";
import { sharedLib } from "@shared/services/shared.service";

const useIntercom = () => {
  const location = useLocation();
  const user = useSelector(sharedLib.selectors.authentication.selectUser);
  const mobileHideLauncher = useMedia(
    [`(max-width: ${HIDE_INTERCOM_LAUNCHER_BREAKPOINT})`],
    [true],
    false
  );
  const isOnboarding = useIsOnboarding();
  const hideLauncher = mobileHideLauncher && !isOnboarding;
  const { boot, shutdown, update } = _useIntercom();

  const getIntercomUserProperties = () => {
    if (user) {
      const customAttributes = getAppcuesAndIntercomUserProperties(
        user,
        isOnboarding
      );
      return {
        userId: user.user_uuid,
        email: user.email,
        userHash: user.uuid_user_hash,
        customAttributes,
      };
    }
    return {};
  };
  const userIntercomProperties = getIntercomUserProperties();

  const isInitialized = useSharedIntercom({
    logout: shutdown,
    update: () =>
      update({
        ...userIntercomProperties,
        lastRequestAt: formatDate(moment()),
      }),
    login: () =>
      boot({
        ...userIntercomProperties,
        hideDefaultLauncher: hideLauncher,
      }),
  });

  useEffect(() => {
    if (isInitialized) {
      update({ hideDefaultLauncher: hideLauncher });
    }
  }, [hideLauncher]);

  useEffect(() => {
    if (isInitialized) {
      update({
        ...userIntercomProperties,
        lastRequestAt: formatDate(moment()),
      });
    }
  }, [location.pathname]);
};

export default useIntercom;
